<template>
  <!-- 角色管理 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" @change="tenantChange" allow-clear>
                <a-select-option value>全部</a-select-option>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="角色名称">
              <a-input v-model="query.roleName" placeholder="请输入角色名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="状态">
              <a-select placeholder="请选择" default-value v-model="query.status">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add
                >新增</a-button
              >
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table
      rowKey="id"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list"
      :columns="columns"
      :loading="dataListLoading"
      :pagination="pagination"
      @change="pageChange"
    >
      <!-- <a-tag color="blue" slot="status" slot-scope="text">{{ text | statusFilter }}</a-tag> -->
      <span slot="status" slot-scope="text">
        <a-tag color="rgb(50, 205, 50" v-if="text == 1">正常</a-tag>
        <a-tag color="rgb(255, 99, 71)" v-else>禁用</a-tag>
      </span>
      <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
    </a-table>
    <a-modal
      title="操作"
      style="top: 20px"
      :width="800"
      v-model="addOrUpdateVisible"
      destroyOnClose
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form class="tenant-form" :form="addOrUpdateForm" :spinning="updateLoading" tip="保存中">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色名称" hasFeedback>
          <a-input
            placeholder="角色名称"
            v-decorator="[
              'roleName',
              { rules: [{ required: true, message: '请输入角色名称' }], initialValue: undefined },
            ]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="角色编码" hasFeedback>
          <a-input
            :disabled="this.isUpdate"
            placeholder="角色编码"
            v-decorator="[
              'roleCode',
              { rules: [{ required: true, message: '请输入角色编码' }], initialValue: undefined },
            ]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
          <a-select
            placeholder="请选择"
            v-decorator="['status', { rules: [{ required: true, message: '请选择状态' }], initialValue: undefined }]"
          >
            >
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否公用"
          v-if="this.$store.state.user.info.systemAdmin"
        >
          <a-select
            placeholder="请选择是否公用"
            v-decorator="[
              'isCommon',
              { rules: [{ required: true, message: '请选择是否公用' }], initialValue: undefined },
            ]"
          >
            >
            <a-select-option :value="0">否</a-select-option>
            <a-select-option :value="1">是</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" hasFeedback>
          <a-input
            placeholder="备注"
            v-decorator="['remark', { rules: [{ required: true, message: '请输入备注' }], initialValue: '' }]"
          />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="权限">
          <span style="color: RGB(196, 196, 196)">
            <a-icon type="exclamation-circle" style="color: red" />
            （权限需要勾选其上级权限才能生效）
          </span>
          <a-tree
            v-decorator="[
              'menuList',
              {
                rules: [{ required: true, message: '请选择权限菜单' }],
                initialValue: undefined,
                valuePropName: 'checkedKeys',
                trigger: 'check',
                validateTrigger: 'check',
              },
            ]"
            :tree-data="menuList"
            checkable
            checkStrictly
            :replaceFields="{
              title: 'menuName',
              key: 'id',
            }"
            @check="checkMenuList"
          ></a-tree>
          <!-- @check="oncheck" -->
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const STATUS = {
  1: '正常',
  2: '禁用',
}
const columns = [
  {
    title: '角色名称',
    dataIndex: 'roleName',
  },
  {
    title: '角色编码',
    dataIndex: 'roleCode',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '备注',
    dataIndex: 'remark',
  },
  {
    title: '所属水司',
    dataIndex: 'tenantName',
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' },
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  mixins: [mixinViewModule],
  name: 'RoleList',
  data() {
    return {
      treeMenuList: [],
      queryUrl: 'manager/roles/page',
      addOrUpdateUrl: 'manager/roles',
      queryOneUrl: 'manager/roles',
      deleteUrl: 'manager/roles',
      query: {
        username: '',
        status: '',
        tenantId: '',
        realName: '',
      },
      updateLoading: false,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      menuList: [],
    }
  },
  filters: {
    statusFilter(key) {
      return STATUS[key]
    },
    permissionFilter(key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    },
  },
  created() {
    this.getAllMenu()
    this.getAllTenant()
  },
  methods: {
    checkMenuList(checkedKeys, e) {
      console.log(checkedKeys)
      console.log(e)
    },
    tenantChange(tenantId) {
      this.queryList()
    },
    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          const params = { id: this.currentId, ...values }
          params.menuList = values.menuList.checked || values.menuList
          this.updateLoading = true
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
              this.updateLoading = false
            })
            .catch(() => {
              this.updateLoading = false
            })
        }
      })
    },
    getAllMenu() {
      this.$http
        .get('/manager/menus/tree')
        .then(({ data }) => {
          
          this.menuList = data
        })
        .catch((e) => {
          console.error(e)
        })
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
